module.exports = __webpack_public_path__ + "static/media/mapSymbols.c43bfc2f.svg";